import {MetaData} from "@qid/core";


export class Signature extends MetaData{
  user;
  signatureImageUrl : string;
  verifyTime : Date;
  _id : string
}
